import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpParams,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    const language = localStorage.getItem('language') || 'en';

    const requestHeader = {
      'accept-language': language,
      lang: language,
    } as any;

    requestHeader.Authorization = `Bearer eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJqeTVCemE4OEFreDUzWjdXRFpOSHBCWm45WTg5azdVMEZuUURPZVpCUk80In0.eyJleHAiOjE3MDQ3MDcwMjMsImlhdCI6MTcwNDcwNjcyMywiYXV0aF90aW1lIjoxNzA0NzA2NzE2LCJqdGkiOiI0ZjQwMjY1Yy03Mjk2LTRjOTQtOGYyZi1iY2M5ZmJiMGE3M2UiLCJpc3MiOiJodHRwczovL2tjLmNvbmN1cmVsLmNvbTo4ODQzL3JlYWxtcy9kY200Y2hlIiwiYXVkIjpbImVsYXN0aWMiLCJyZWFsbS1tYW5hZ2VtZW50IiwiYWNjb3VudCJdLCJzdWIiOiI2MzgzZjZjNy1hYWNlLTQ4MzAtYTY4MS04N2RkN2ZlY2Q2YTgiLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJkY200Y2hlZS1hcmMtdWkiLCJub25jZSI6Ijc0NGI2N2Q0LTc5NDktNDJhMy1iNDNlLWI3OWE2YmZiODVjMSIsInNlc3Npb25fc3RhdGUiOiJlMTJhNzZiOC1iMzhkLTQzZDUtYTk5YS1iZTJkNzg2YmVmOGIiLCJhY3IiOiIwIiwiYWxsb3dlZC1vcmlnaW5zIjpbImh0dHBzOi8vdm5hLmNvbmN1cmVsLmNvbTo4NDQzIiwiaHR0cDovL3ZuYS5jb25jdXJlbC5jb206ODA4MCJdLCJyZWFsbV9hY2Nlc3MiOnsicm9sZXMiOlsiQURNSU5JU1RSQVRPUiIsImF1ZGl0bG9nIiwiYXV0aCIsInJvb3QiXX0sInJlc291cmNlX2FjY2VzcyI6eyJyZWFsbS1tYW5hZ2VtZW50Ijp7InJvbGVzIjpbInZpZXctcmVhbG0iLCJ2aWV3LWlkZW50aXR5LXByb3ZpZGVycyIsIm1hbmFnZS1pZGVudGl0eS1wcm92aWRlcnMiLCJpbXBlcnNvbmF0aW9uIiwicmVhbG0tYWRtaW4iLCJjcmVhdGUtY2xpZW50IiwibWFuYWdlLXVzZXJzIiwicXVlcnktcmVhbG1zIiwidmlldy1hdXRob3JpemF0aW9uIiwicXVlcnktY2xpZW50cyIsInF1ZXJ5LXVzZXJzIiwibWFuYWdlLWV2ZW50cyIsIm1hbmFnZS1yZWFsbSIsInZpZXctZXZlbnRzIiwidmlldy11c2VycyIsInZpZXctY2xpZW50cyIsIm1hbmFnZS1hdXRob3JpemF0aW9uIiwibWFuYWdlLWNsaWVudHMiLCJxdWVyeS1ncm91cHMiXX0sImFjY291bnQiOnsicm9sZXMiOlsibWFuYWdlLWFjY291bnQiLCJ2aWV3LWFwcGxpY2F0aW9ucyIsIm1hbmFnZS1jb25zZW50IiwiZGVsZXRlLWFjY291bnQiLCJ2aWV3LXByb2ZpbGUiXX19LCJzY29wZSI6Im9wZW5pZCBwcm9maWxlIGVtYWlsIiwic2lkIjoiZTEyYTc2YjgtYjM4ZC00M2Q1LWE5OWEtYmUyZDc4NmJlZjhiIiwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJyb290IiwiZ2l2ZW5fbmFtZSI6IiIsImZhbWlseV9uYW1lIjoiIn0.FsD-p8QOq2SqPGGY3YRtq5yV0oCgFtiIpOLm6zVQD5e1tnXftjHuNg9ZTZkmoa1KlN8_0TBVtxmXCuNplG1B3IpF5xZFqEdf1Za9fMZXv_YkMJjFq0-M_m0bElV941VFLDzm0DGuwfGcMtnUylqEJ282zeyUx30WDmW-rM3XWQkpH45Vik0ynBeyIcvrruAtbarAtT8UQRjTG9BByJeAKH2tP8ME18frdkU67dPLbJxOd-N3jX1MEOOY7g3PsGi8EKF9ZfQDEPMyrwOQ4kS1UhU_G5Wg8K463Sxyla_pKsb3btLMdpMxlrxwnZzB3r22r2_MHhB47gu5yjtRC0kvIA`;

    this.dateReplacer(request.body);
    return next.handle(request);
  }
  dateReplacer(obj: any) {
    if (obj) {
      for (const k in obj) {
        if (obj.hasOwnProperty(k)) {
          if (obj[k] instanceof Object) {
            obj[k] = this.dateReplacer(obj[k]);
          }
          if (obj[k] instanceof Date) {
            obj[k] = new Date(`${obj[k]} UTC`);
          }
        }
      }
      return obj;
    }
  }
}
